<template>
    <div class="m-expack">
        <h5 class="title"></h5>

        <div class="expack-view">
            <div class="view-item">
                <h6 class="title t-1"></h6>

                <div class="notice">
                    <p>解锁鸡王奖励即可购买</p>
                    <p>（全部获得）</p>
                </div>

                <div class="reward-list" style="padding : 0 80px;">
                    <div class="reward-item" v-for="(item,index) in pack_config['box_1']" :key="index"  @click="$item_tips(item.id)">
                        <game-item :id="item.id" :num="item.num" :locked="true"></game-item>
                    </div>
                </div>

                <div class="u-btn apply apply-199" :class="{'dismiss' : ($store.state.account.uflag & 8) == 8}" @click="apply_pack(8,199)"></div>
            </div>
            <div class="view-item">
                <h6 class="title t-2"></h6>

                <div class="notice">
                    <p>解锁鸡王奖励且达到</p>
                    <p>500经验值可购买（任选其一）</p>
                </div>

                <div class="reward-list">
                    <div class="reward-item" v-for="(item,index) in pack_config['box_2']" :key="index"  @click="$item_tips(item.id)">
                        <game-item :id="item.id" :num="item.num" :locked="true"></game-item>
                    </div>
                </div>                
                
                <div class="u-btn apply apply-688" :class="{'dismiss' : ($store.state.account.uflag & 16) == 16}" @click="apply_pack(16,688)"></div>                
            </div>
        </div>
    </div>
</template>

<style scoped>
h5.title{
    width: 479px;
    height: 72px;
    margin: 0 auto 20px;
    background-image: url(~@/assets/images/title-shop-2.png);
}

.expack-view{
    display: flex;
    justify-content: space-between;
}

.view-item{
    position: relative;
    width: 353px;
    height: 589px;
    padding-top: 35px;
    background-image: url(~@/assets/images/bg-fuli-item.png);
    box-sizing: border-box;  
}

h6.t-1{
    width: 254px;
    height: 30px;
    margin: 0 auto 20px;
    background-image: url(~@/assets/images/title-pack-2.png);
}

h6.t-2{
    width: 254px;
    height: 30px;
    margin: 0 auto 20px;
    background-image: url(~@/assets/images/title-pack-3.png);
}

.box{
    position: relative;
    width: 161px;
    height: 161px;
    margin: 0 auto;
    background-image: url(~@/assets/images/bg-fuli-box.png);
}

.layer-box{
    position: absolute;
    left: 50%;
    top: 50%;
    width: 73px;
    height: 72px;
    margin: -36px 0 0 -36px;
    background-image: url(~@/assets/images/box.png);
}

.reward-list{
    position: absolute;
    left: 0;
    top: 170px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;
    margin: 10px 0 10px;
    padding: 0 20px;
}

.reward-item{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 84px;
    height: 84px;
    margin-bottom: 40px;
    background-image: url(~@/assets/images/bg-item.png);
}

.notice{
    font-size: 22px;
    text-align: center;
    color: #9c603a;
}

.u-btn.apply{
    position: absolute;
    left: 50%;
    bottom: 67px;
    width: 225px;
    height: 60px;
    transform: translateX(-50%);
    margin: 12px auto 0;
}

.u-btn.apply.apply-199{
    background-image: url(~@/assets/images/btn-apply-199.png);
}

.u-btn.apply.apply-199.dismiss{
    background-image: url(~@/assets/images/btn-apply-199D.png);
}

.u-btn.apply.apply-688{
    background-image: url(~@/assets/images/btn-apply-688.png);
}

.u-btn.apply.apply-688.dismiss{
    background-image: url(~@/assets/images/btn-apply-688D.png);
}

.u-btn.apply.apply-199.disabled{
    background-image: url(~@/assets/images/btn-apply-199D.png);
}

.u-btn.apply.apply-688.disabled{
    background-image: url(~@/assets/images/btn-apply-688D.png);
}
</style>

<script>
export default {
    data (){
        return {
            pack_config : {
                'box_1' : [{name : '中级士兵卡',id : 'D355',num : 2},{name : '征战印记(30天）',id : 'X230',num : 10},{name : '活跃自选礼包',id : 'KQ48',num : 5},{name : '珍宝自选',id : 'D774',num : 1}],
                'box_2' : [{name : '高级宠物幻化券',id : 'ZZ73',num : 8},{name : '征战印记(30天）',id : 'X230',num : 150},{name : '空相宝莲',id : 'KW99',num : 10},{name : '鸿蒙无极',id : 'K814',num : 20},{name : '蓬莱仙魄',id : 'X217',num : 50},{name : '高级士兵卡',id : 'AG00',num : 1}],
            },
        }
    },
    methods : {
        apply_pack(gid,cost){
            if(!this.$store.state.userinfo.uid){
                return this.$mslogin.open();
            }

            if(!this.$store.state.userinfo.areaId){
                this.$toast('请绑定大区');


                return this.$bind_modal();
            }

            if((this.$store.state.account.uflag & gid) == gid)return this.$toast('无法再购买');

            this.$comfirm_Modal({
                text : '购买该礼包吗？',
                gid : gid,
                num : 1,
                cost : cost,
            })

            // this.$axios.post(globalThis.ajax_url_map.buy,{
            //     giftId : gid,
            // })
            // .then(
            //     res => {                   
            //         this.$success_Modal({text : '购买成功'});
            //         this.$update_userType(10)
            //     },
            //     rej => {
            //         let type = rej.code == 416 ? 2 : 1;
            //         type == 2 ? this.$error_Modal({text : rej.message , type : type}) : this.$toast(rej.message);
            //     },
            // )       
        },
    },      
}
</script>


// WEBPACK FOOTER //
// src/components/Shop/expack.vue